import { render } from "./CargaDocumentosDinamica.vue?vue&type=template&id=289d7066&scoped=true"
import script from "./CargaDocumentosDinamica.vue?vue&type=script&lang=js"
export * from "./CargaDocumentosDinamica.vue?vue&type=script&lang=js"

import "./CargaDocumentosDinamica.vue?vue&type=style&index=0&id=289d7066&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289d7066"]])

export default __exports__